import React from 'react';
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Card,
  CardContent,
} from '@mui/material';
import { formatDate } from '../../utils/dateFormat';

const FeeTransactions = ({ transactions, monthLabels, onBack }) => {
  return (
    <Box sx={{ pb: 2 }}>
      <Box sx={{ p: 2, pb: 1 }}>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Fee Transactions
        </Typography>
      </Box>

      <Box sx={{ px: 2 }}>
        {transactions.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body2" color="text.secondary">
              No fee transactions recorded yet.
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {transactions.map((payment) => {
              const monthIndex = Number(payment.billing_month);
              const monthLabel =
                !Number.isNaN(monthIndex) && monthIndex >= 1 && monthIndex <= 12
                  ? monthLabels[monthIndex - 1]
                  : null;
              const periodLabel = monthLabel
                ? `${monthLabel} ${payment.fee_session || ''}`.trim()
                : payment.fee_session || '—';

              return (
                <Card
                  key={payment.id}
                  sx={{
                    borderRadius: 3,
                    boxShadow: 2,
                  }}
                >
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                      <Typography variant="subtitle2" fontWeight={700}>
                        {payment.category_name || 'Fee Payment'}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {formatDate(payment.payment_date)}
                      </Typography>
                    </Box>
                    <Typography variant="h6" color="primary.main" fontWeight={700} sx={{ mb: 1 }}>
                      ₹{Number(payment.amount_paid || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      <Typography variant="body2" color="text.secondary">
                        Method: {payment.payment_method || '—'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Period: {periodLabel}
                      </Typography>
                      {payment.reference_number && (
                        <Typography variant="body2" color="text.secondary">
                          Reference: {payment.reference_number}
                        </Typography>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default FeeTransactions;

